import type { ReactNode } from 'react';

/**
 * Chrome for every unauthenticated customer page.
 *
 * The customer portal is the only one an end user sees, so it carries the
 * brand: full-bleed colour, the logo at size, welcoming copy. Deliberately the
 * lightest and friendliest of the three, so it is never mistaken for the staff
 * or partner portals.
 */
export default function AuthShell({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-700 via-brand-600 to-brand-400 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white/95 backdrop-blur rounded-3xl shadow-2xl p-8">
          {/* Lockup on white: the dark version. Minimum lockup width is 130px
              (Manual de Identidad §02), which h-7 clears at this aspect. */}
          <div className="text-center mb-8">
            <img src={`${import.meta.env.BASE_URL}logo-text-dark.png`} alt="tucorreoypagina.com" className="h-9 mx-auto" />
          </div>

          <h2 className="text-xl font-semibold text-center text-gray-900">{title}</h2>
          {subtitle && <p className="text-sm text-gray-500 text-center mt-1">{subtitle}</p>}

          <div className="mt-6">{children}</div>
        </div>
      </div>
    </div>
  );
}
